export default __webpack_public_path__ + "c931a61badca34016cb6bdb025d35baf.png";